import React from "react";
import "../App.css"

const TimeoutPopup = ({ show, onRefresh,headerMessage,Message }) => {
  if (!show) return null;

  return (
    <div className="overlayStyle">
      <div className="popupStyle">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6v6l4 2m6-2a10 10 0 11-20 0 10 10 0 0120 0z"
          />
        </svg>
        <h2 style={{ fontSize: "24px", margin: "15px 0" }}>{headerMessage}</h2>
        <p>{Message}</p>
        <button className="buttonStyle" onClick={onRefresh}>
          Refresh
        </button>
      </div>
    </div>
  );
};

export default TimeoutPopup;
